import {
  GenerateProductsFromImagesRequestDto,
  GenerateProductsFromImagesResponseDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';

const GENERATE_PRODUCTS_FROM_IMAGES_URL =
  '/v1/products/generate/products-from-images';

export const productsFromImagesApi = cirrusApi.injectEndpoints({
  endpoints: (builder) => ({
    generateProductsFromImages: builder.mutation<
      GenerateProductsFromImagesResponseDto,
      GenerateProductsFromImagesRequestDto
    >({
      query: (requestDto: GenerateProductsFromImagesRequestDto) => ({
        method: 'POST',
        url: GENERATE_PRODUCTS_FROM_IMAGES_URL,
        data: requestDto,
      }),
    }),
  }),
});

export const { useGenerateProductsFromImagesMutation } = productsFromImagesApi;
